import { useState } from 'react';
import CrudTable from '../../components/CrudTable';
import { supabase } from '../../lib/supabase';

// QT#5: "Chương trình khuyến mãi trong ngày" = lọc các promo is_daily của hôm nay.
export default function PromotionsAdmin() {
  const [todayOnly, setTodayOnly] = useState(false);
  const today = new Date().toISOString().slice(0, 10);

  const fetchRows = todayOnly
    ? async () => {
        const { data } = await supabase
          .from('promotions').select('*')
          .eq('is_daily', true)
          .order('created_at', { ascending: false });
        return (data || []).filter((p) => !p.starts_at || p.starts_at === today);
      }
    : undefined;

  return (
    <div>
      <div className="row" style={{ marginBottom: 10 }}>
        <button className={`chip ${!todayOnly ? 'active' : ''}`} onClick={() => setTodayOnly(false)}>Tất cả CTKM</button>
        <button className={`chip ${todayOnly ? 'active' : ''}`} onClick={() => setTodayOnly(true)}>⚡ CTKM trong ngày (hôm nay)</button>
      </div>
      <CrudTable
        title="🏷️ Chương trình khuyến mãi"
        table="promotions"
        defaults={{ active: true, is_daily: false, starts_at: today }}
        fetchRows={fetchRows}
        refreshKey={todayOnly ? 1 : 0}
        columns={[
          { key: 'title', label: 'Tiêu đề (VI)', type: 'text', required: true },
          { key: 'title_en', label: 'Tiêu đề (EN)', type: 'text', inTable: false },
          { key: 'description', label: 'Mô tả (VI)', type: 'textarea', inTable: false },
          { key: 'description_en', label: 'Mô tả (EN)', type: 'textarea', inTable: false },
          { key: 'discount_percent', label: '% giảm', type: 'number' },
          { key: 'starts_at', label: 'Bắt đầu', type: 'date' },
          { key: 'ends_at', label: 'Kết thúc', type: 'date' },
          { key: 'is_daily', label: 'CTKM trong ngày', type: 'checkbox' },
          { key: 'active', label: 'Đang chạy', type: 'checkbox' },
        ]}
      />
    </div>
  );
}
